import produce from 'immer';
import { SubscriptionStore } from '.';
import { FossaSubscriptionPlan, FossaSubscriptionPlanPreview, ReduxActionResponse } from '../../types';
import { createReducer, getErrorStatus, getInitialStatus, getPendingStatus } from '../utils';
import { CANCEL_SUBSCRIPTION, FETCH_SUBSCRIPTION, FETCH_SUBSCRIPTION_PREVIEW, UPDATE_SUBSCRIPTION } from './actions';

const getInitialState = (): SubscriptionStore => ({
  subscription: null,
  subscriptionPreview: null,
  canceled: false,
  updated: false,
  status: getInitialStatus(),
});

const subscriptionReducer = createReducer(getInitialState(), {
  [`${FETCH_SUBSCRIPTION}_PENDING`]: (state: SubscriptionStore) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${FETCH_SUBSCRIPTION}_FULFILLED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.subscription = action.payload.data as FossaSubscriptionPlan;
    draftState.status = getInitialStatus();
  }),
  [`${FETCH_SUBSCRIPTION}_REJECTED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),
  [`${UPDATE_SUBSCRIPTION}_PENDING`]: (state: SubscriptionStore) => produce(state, draftState => {
    draftState.updated = false;
    draftState.status = getPendingStatus();
  }),
  [`${UPDATE_SUBSCRIPTION}_FULFILLED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.updated = true;
    draftState.subscription = action.payload.data as FossaSubscriptionPlan;
    draftState.status = getInitialStatus();
  }),
  [`${UPDATE_SUBSCRIPTION}_REJECTED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.updated = false;
    draftState.status = getErrorStatus(action.payload);
  }),
  [`${FETCH_SUBSCRIPTION_PREVIEW}_PENDING`]: (state: SubscriptionStore) => produce(state, draftState => {
    draftState.status = getPendingStatus();
  }),
  [`${FETCH_SUBSCRIPTION_PREVIEW}_FULFILLED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.subscriptionPreview = action.payload.data as FossaSubscriptionPlanPreview;
    draftState.status = getInitialStatus();
  }),
  [`${FETCH_SUBSCRIPTION_PREVIEW}_REJECTED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.status = getErrorStatus(action.payload);
  }),
  [`${CANCEL_SUBSCRIPTION}_PENDING`]: (state: SubscriptionStore) => produce(state, draftState => {
    draftState.canceled = false;
    draftState.status = getPendingStatus();
  }),
  [`${CANCEL_SUBSCRIPTION}_FULFILLED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.canceled = true;
    draftState.subscription = action.payload.data as FossaSubscriptionPlan;
    draftState.status = getInitialStatus();
  }),
  [`${CANCEL_SUBSCRIPTION}_REJECTED`]: (state: SubscriptionStore, action: ReduxActionResponse) => produce(state, draftState => {
    draftState.canceled = false;
    draftState.status = getErrorStatus(action.payload);
  }),
});

export default subscriptionReducer;
